import { type OrganizationData } from 'chaika-frontend-types/frontend-cms';

import { store } from '@store';

import { OrganizationApi } from '@organization/api/OrganizationApi';

export enum FileType {
    Stamp = 'stamp',
    Signature = 'signature',
    StampString = 'stampString',
    SignatureString = 'signatureString',
}

class OrganizationFileService {
    public async reloadWithFiles(id: string): Promise<OrganizationData> {
        const { organizations } = await OrganizationApi.getList({ ids: id, withFiles: true });

        if (organizations?.length > 0) {
            if (store.organizationList.has(id)) {
                store.organizationList.update(id, organizations[0]);
            } else {
                store.organizationList.add(organizations);
            }
        }

        return organizations?.[0];
    }
}

export const organizationFileService = new OrganizationFileService();
